export const AppConfig = {
  URL: "https://opms-backend.isttestdev.ng/api/v1",
  // URL: "http://172.20.10.2:8000/api/v1",
}

// export const AppConfig = {
//   URL: "http://54.176.199.246/api/v1",
// }
